
export const getDynamicConfigValue = (envKey) => {

    var value = null;
    if (window._dynamicEnv_) {
        value = window._dynamicEnv_[envKey];
    }
    if (!value) {
        value = process.env[envKey];
    }
    return value;
}

